export default __webpack_public_path__ + "static/media/lottery-icon.5a9a0867.webp";